import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function H() {
    const { useLang } = useGlobal();
    const { t } = useLang('corporatesocialresponsibility');

    const list = [
        'https://websiteoss.ecoflow.com/upload/image/1753859993644/1-WRN%20Ambassador%20logo%201.png',
        'https://websiteoss.ecoflow.com/upload/image/1753859993310/2-Red%20Ligntning%20logo%201.png',
        'https://websiteoss.ecoflow.com/upload/image/1753859991749/Group%204.png',
        'https://websiteoss.ecoflow.com/upload/image/1753859519645/4-Social%20Emergency%20Management%20Alliance%20logo.jpg',
        'https://websiteoss.ecoflow.com/upload/image/1753859519923/5-%E8%93%9D%E5%A4%A9%E6%95%91%E6%8F%B4.jpg',
        'https://websiteoss.ecoflow.com/upload/image/1753859991575/%F0%9F%9B%A0-Blocks.png',
        'https://websiteoss.ecoflow.com/upload/image/1753859992276/7-Footprint%20Project%20logo%201.png',
        'https://websiteoss.ecoflow.com/upload/image/1753859991906/8-Special%20Forces%20Charitable%20Trust%20logo%201.png',
    ];
    return (
        <div className={`csr-G ${css['csr-G']}`}>
            <EcoSectionCommon title={t('secH_title')} desc={t('secH_desc')} />
            <div className="csr-G-content">
                {list.map((i, idx) => (
                    <div className="csr-G-item" key={idx}>
                        <img src={i} />
                    </div>
                ))}
            </div>
        </div>
    );
}
